import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _mapField2PermId;
import { getXsrfToken } from "../cgi/cookies";
import { PermissionDocType, PermissionId } from "../cgi/permissions";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { PermissionField } from "../common/permission";
import { requestV2Cgi } from "../data-source/network-request";
import { TencentDocMimeType } from "../model/file-node";

/**
 * 查询一批文件或文件夹是否符合给定的权限
 */
export function getPermissionList(params) {
  return new PermissionsRequest(params).send();
}
export var PermissionsRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(PermissionsRequest, _DriveRequest);
  var _super = _createSuper(PermissionsRequest);
  function PermissionsRequest() {
    _classCallCheck(this, PermissionsRequest);
    return _super.apply(this, arguments);
  }
  _createClass(PermissionsRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", requestV2Cgi(payload));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var field = params.field,
        targets = params.targets;
      return {
        method: 'post',
        url: "".concat(PERMISSIONS_URL, "?xsrf=").concat(getXsrfToken()),
        data: {
          permission_id: mapField2PermId[field],
          docs: getDocsByPermTargets(targets)
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (!response) {
        throw new DriveApiError({
          name: "PermissionResultError",
          message: 'No response returned. Please capture the network packet to check the error.',
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return response.result.permission_info;
    }
  }]);
  return PermissionsRequest;
}(DriveRequest);
var mapField2PermId = (_mapField2PermId = {}, _defineProperty(_mapField2PermId, PermissionField.CanCopy, PermissionId.CopyFile), _defineProperty(_mapField2PermId, PermissionField.CanExport, PermissionId.DumpFile), _defineProperty(_mapField2PermId, PermissionField.CanPrint, PermissionId.PrintFile), _defineProperty(_mapField2PermId, PermissionField.CanView, PermissionId.ViewFile), _defineProperty(_mapField2PermId, PermissionField.CanEdit, PermissionId.EditFile), _mapField2PermId);
var getDocsByPermTargets = function getDocsByPermTargets(permTargets) {
  return permTargets.map(function (target) {
    return {
      id: target.id,
      type: target.mimeType === TencentDocMimeType.TecentFolder || target.mimeType === TencentDocMimeType.TencentCollaborationSpace ? PermissionDocType.Folder : PermissionDocType.File
    };
  });
};
var PERMISSIONS_URL = "//".concat(location.host, "/api/permission/batch_get_object");
//# sourceMappingURL=permissions.js.map